import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=d458dcf2&scoped=true&lang=pug"
import script from "./ReservationDetail.vue?vue&type=script&lang=js"
export * from "./ReservationDetail.vue?vue&type=script&lang=js"
import style0 from "./ReservationDetail.vue?vue&type=style&index=0&id=d458dcf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d458dcf2",
  null
  
)

export default component.exports